"use strict";

exports.__esModule = true;
exports.default = void 0;
var _FileInput = _interopRequireDefault(require("./FileInput.js"));
exports.default = _FileInput.default;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }